import type { Router } from 'vue-router'
// @ts-expect-error importing untyped JS module into TypeScript
import { logEvent } from '@/services/clients/firebase'
import type { WhatsNewAction } from './whats-new-items'
import type { ResolvedWhatsNewCta } from './eligibility'

/** Does what a call to action says: navigate, open a link, or hand an action to the page shell. */
export function followWhatsNewCta (
  router: Router,
  itemId: string,
  cta: ResolvedWhatsNewCta,
  source: 'banner' | 'panel',
  onAction: (_action: WhatsNewAction) => void
) {
  logEvent('whats_new_cta_clicked', { item_id: itemId, source, variant: cta.variant })

  if (cta.action) {
    onAction(cta.action)
  } else if (cta.route) {
    void router.push(cta.route)
  } else if (cta.href) {
    window.open(cta.href, '_blank', 'noopener')
  }
}

/** The upsell version's upgrade button. */
export function followWhatsNewUpgrade (itemId: string, source: 'banner' | 'panel', upgrade: () => void) {
  logEvent('whats_new_upgrade_clicked', { item_id: itemId, source })
  upgrade()
}
